import React from "react"
import AboutHero from "./AboutHero"
import AboutVideo from "./aboutVideo"
import Targets from "./Targets"
import AboutImages from "./AboutImages"
import ServicesNumbers from "./ServicesNumbers"
const AboutPage = ({ lang }) => {
  return (
    <div>
      <AboutHero lang={lang} />
      <AboutVideo lang={lang} />
      <Targets lang={lang} />
      <AboutImages lang={lang} />
      <ServicesNumbers lang={lang} />
    </div>
  )
}

export default AboutPage
